/**
*
* PluginVersionListPage
*
*/

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import summaryShape from 'Workspace/types/pluginSummary';

import {
  PageWrapper,
  PageViewport,
} from 'components/PageStyles';
import enhanceWithThemes from 'hocs/enhanceWithThemes';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Link from 'data/Link';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import gtmService from 'utils/gtm/gtmService';
import { GTM_EVENT_TYPES } from 'utils/gtm/constants';

import themes from './themes';
import messages from './messages';
import VersionsList from './VersionsList';
import { ContentWrapper } from './styles';

const PluginVersionListPage = ({ summary, match }) => {
  useEffect(() => {
    if (location) {
      const { pathname } = location;
      gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: pathname } });
    }
  }, []);
  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage(messages.pageTitle)}</title>
        <meta
          name="description"
          content={intl.formatMessage(messages.pageDescription)}
        />
      </Helmet>
      <Sidebar navigation={<HomeNavigation selectedKey="plugins" />} />
      <PageViewport>
        <WorkspaceHeader
          links={[
            new Link('/plugins', 'Plugins'),
            new Link(`/plugins/${match.params.pluginId}`, summary ? summary.name : match.params.pluginId),
          ]}
          title={intl.formatMessage(messages.breadcrumb)}
        />
        <ContentWrapper>
          <VersionsList pluginId={match.params.pluginId} />
        </ContentWrapper>
      </PageViewport>
    </PageWrapper>
  );
};

PluginVersionListPage.propTypes = {
  summary: summaryShape,
  match: PropTypes.shape({
    params: PropTypes.shape({
      pluginId: PropTypes.string,
    }),
  }),
};

export default enhanceWithThemes(PluginVersionListPage, themes);
